import { DataLogRq, SourcePage } from '@domain/rq/DataLog';
import { ProfileBasicFormVO } from '@domain/vo/profile/ProfileBasicFormVO';

export class ProfileBasicInfoRq {
  name: string;
  profileImageUid: string | null;
  birthDate: string;
  countryCode: string;
  mobile: string;
  email: string;
  sourcePage?: SourcePage;

  constructor(vo: ProfileBasicFormVO & DataLogRq) {
    this.name = vo.name || '';
    this.profileImageUid = vo.profileImageUid || null;
    this.birthDate = vo.birthDate || '';
    this.countryCode = vo.countryCode || '';
    this.mobile = vo.mobile?.replace(/[^0-9]/g, '') || '';
    this.email = vo.email || '';
    this.sourcePage = vo.sourcePage;
  }
}
